import { render, staticRenderFns } from "./UserSecurity.vue?vue&type=template&id=92a42736&scoped=true&"
import script from "./UserSecurity.vue?vue&type=script&lang=js&"
export * from "./UserSecurity.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurity.vue?vue&type=style&index=0&id=92a42736&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a42736",
  null
  
)

export default component.exports